import { useQuery } from 'react-query';
import axios from 'axios';
import { apiBaseUrl } from 'config';
import { useAuth } from '../Contexts/AuthProvider';

const getUniqueUnits = async ({ companyId, section = 'units', search }) => {

    const urlMap = {
        'units': `${apiBaseUrl}/units/unique`,
        'locations': `${apiBaseUrl}/locations/unique`,
    }

    const url = urlMap[section] || urlMap['units'];

    const response = await axios.get(url, {
        headers: { 'CompanyId': companyId },
        params: search ? { search } : undefined,
    });
    if (response.status === 204) return []
    return response.data;
};

export default function useUniqueUnits(section = 'units') {
    const { userLoaded, currentCompany, currentUser } = useAuth();
    
    const shouldFetch = userLoaded && !(section === 'locations' && currentUser && currentUser.isOneUnitPassword());

    return useQuery(
        ['unique-units', section, currentCompany],
        () => getUniqueUnits({ companyId: currentCompany?.id, section }),
        {
            initialData: [],
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            enabled: shouldFetch,
        });
}

export function useUniqueUnitsSearch(section = 'units', search = '') {
    const { userLoaded, currentCompany } = useAuth();
    const term = (search || '').trim();

    return useQuery(
        ['unique-units-search', section, currentCompany, term],
        () => getUniqueUnits({ companyId: currentCompany?.id, section, search: term }),
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            enabled: userLoaded && !!term,
        });
}
